import { Float32BufferAttribute } from 'three';

import {
  BinaryBodyReference,
  CesiumPnts,
  getFeatureElementSize,
  PntsFeatureTable,
} from '../../../../../loader/cesium/content/pnts/types';
import { BufferAttributeAdapter } from './buffer-attribute-adapter';

export const NormalBufferAttribute: BufferAttributeAdapter = (
  feature: keyof PntsFeatureTable,
  pntsData: CesiumPnts,
) => {
  const buffer = pntsData.features.featureBody;
  const offset = (pntsData.features.featureTable[feature] as BinaryBodyReference).byteOffset;
  const pointsCount = pntsData.features.featureTable.POINTS_LENGTH;
  return new Float32BufferAttribute(
    new Float32Array(buffer, offset, getFeatureElementSize(feature) * pointsCount),
    getFeatureElementSize(feature),
    true,
  );
};
